// Chart page route (/$region/curves/$chartKey): the chart key from the path, the document from ?doc= (the region's current version when absent) and the chart page; its breadcrumb names the figure.
import { createFileRoute } from "@tanstack/react-router";

import { ChartScreen } from "@/features/curves/ChartScreen";
import { chartSearchSchema } from "@/features/curves/search";

export const Route = createFileRoute("/_app/$region/curves_/$chartKey")({
  validateSearch: chartSearchSchema,
  staticData: { crumb: "Chart" },
  component: ChartRoute,
});

function ChartRoute() {
  const { chartKey } = Route.useParams();
  const search = Route.useSearch();
  return <ChartScreen chartKey={chartKey} docUid={search.doc} />;
}
